// @flow
import { KEY } from './constants'

export const getAccount = (state: Object) => state[KEY]
